import React, { Component } from "react";

class SectionPadding extends Component {
  render() {
    return (
      <div className="lead-text uk-margin-large-right uk-margin-remove-right@s uk-margin-large-left uk-margin-remove-left@s">
        {this.props.children}
      </div>
    );
  }
}

export default SectionPadding;
